const MAGIC_WAND = `
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.437 4.83366V2.54199M17.437 18.5837V16.292M9.41618 10.5628H11.7078M23.1662 10.5628H25.4578M20.6453 13.7712L22.0203 15.1462M20.6453 7.35449L22.0203 5.97949M3.68701 24.3128L13.9995 14.0003M14.2287 7.35449L12.8537 5.97949" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;

export default MAGIC_WAND;
